"use client";

import React from "react";
import { MapPin, Navigation } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function OurLocalPresence() {
  return <section data-section-id="35790" id="our-location" className="bg-background text-foreground py-24 relative overflow-hidden">
      <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-1/4 w-96 h-96 bg-secondary/5 rounded-full blur-3xl" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="max-w-3xl">
          <div className="space-y-12">
            <div className="space-y-6">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary/10 text-secondary text-sm font-semibold tracking-wide uppercase">
                <MapPin className="size-4" />
                <span>Local Expertise</span>
              </div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-primary font-sans leading-[1.1]">
                Visit Our <span className="text-secondary">Orlando</span> Office
              </h2>
              <p className="text-lg text-muted-foreground max-w-xl leading-relaxed"><div data-ast-id="f:/src/pages/Contact/sections/OurLocalPresence.tsx|sig:5mhms5" data-ast-start="1281" data-ast-end="1335">6900 Turkey Lake Rd #2-3 Orlando, FL 32819</div><div data-ast-id="f:/src/pages/Contact/sections/OurLocalPresence.tsx|sig:5m0y5m" data-ast-start="1335" data-ast-end="1361">(407) 298-9777</div><div data-ast-id="f:/src/pages/Contact/sections/OurLocalPresence.tsx|sig:5lz45s" data-ast-start="1361" data-ast-end="1394">info@4rentorlando.com</div><div data-ast-id="f:/src/pages/Contact/sections/OurLocalPresence.tsx|sig:5liii0" data-ast-start="1411" data-ast-end="1423" contenteditable="false" style={{}}></div></p>
            </div>

            <div className="pt-4">
              <Button asChild variant="default" size="lg" className="rounded-lg px-10 h-14 text-base font-semibold shadow-xl shadow-primary/10 hover:shadow-primary/20 transition-all">
                <Link to="https://maps.app.goo.gl/gM49rUCirQrFw9HQA">
                  <Navigation className="mr-2 h-5 w-5" />
                  Get Directions
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}